import { RetailerKpiOption, SaleType, TrendsKpi } from '@models/Products';
import { Kpi } from '@utils/Formatters';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { SaleTypeRetailerKpi } from '@components/products-line-charts/Types';
import React from 'react';
import { PageType } from '@utils/pageConfig/Types';
import {
  createChartAxisConfig,
  processProductsRetailerLineChartData,
} from '@data-visualization/utilities/line-chart/FormatLineChartData';
import { ChartKeys } from '@const/ChartKeys';
import { WithLineChart } from '@components/design';
import { useExportImages } from '@hooks/export/UseExportChartImage';
import { generateUniqueChartKeys } from '@data-visualization/utilities/GenerateUniqueChartKeys';
import { getSaleTypeRetailerShareKpi } from '@utils/lineChart/lineChartUtils';

interface Props {
  data: TrendsKpi;
  selectedPeriodicity: Periodicity;
  currency: string;
  selectedLineChartSaleType: SaleType;
  selectedRetailerOption: RetailerKpiOption;
}

const ProductsRetailerLineChart: React.FC<Props> = ({
  data,
  selectedPeriodicity,
  currency,
  selectedLineChartSaleType,
  selectedRetailerOption,
}) => {
  const { handleExportImage } = useExportImages(PageType.RI_PRODUCT);

  const mainKpi: Kpi = getSaleTypeRetailerShareKpi(selectedLineChartSaleType, selectedRetailerOption);
  const secondKpi: Kpi = SaleTypeRetailerKpi[selectedLineChartSaleType];
  const chartData = processProductsRetailerLineChartData(data, selectedLineChartSaleType, selectedRetailerOption);

  return (
    <div data-testid="products-retailer-line-chart">
      <WithLineChart
        data={chartData}
        fullWidth
        onExport={(image) =>
          handleExportImage(image, generateUniqueChartKeys(chartData, ChartKeys[PageType.RI_PRODUCT].RETAILER))
        }
        {...createChartAxisConfig[PageType.RI_PRODUCT][ChartKeys[PageType.RI_PRODUCT].RETAILER](
          selectedPeriodicity,
          currency,
          mainKpi,
          secondKpi,
        )}
      ></WithLineChart>
    </div>
  );
};

export default React.memo(ProductsRetailerLineChart);
